module.exports = __webpack_public_path__ + "img/giaCertificate@2x.a22cd32.webp";